import 'react-loading-skeleton/dist/skeleton.css'

import { Document, Page, View } from '../../compiler'
import CategoryBadges from './CategoryBadges'
import CultureFitContainer from './CultureFitContainer'
import DimensionCard from './DimensionCard'
import styles, { CATEGORY_BADGES_WIDTH_PERCENT } from './styles'
import TitleDescription from './TitleDescription'

const TalentProfileLoading = () => {
  const pageProps = {
    style: styles.pageContainer
  }

  // Mock data for loading state
  const mockCategoryBadges = Array(4).fill({
    title: '',
    data: Array(4).fill({})
  })

  const mockDimensionCards = Array(4).fill({
    title: '',
    talent_score: 0,
    endpole_left: '',
    endpole_right: '',
    insight_description: ''
  })

  return (
    <Document>
      {/** HEADER + SUMMARY */}
      <Page>
        <View>
          <TitleDescription title='' description='' isLoading={true} />
          <View
            id='talent_profile_summary'
            style={styles.categoryBadgesContainer}
          >
            {mockCategoryBadges.map((_, index) => (
              <CategoryBadges
                key={index}
                style={{ width: CATEGORY_BADGES_WIDTH_PERCENT }}
                title=''
                facts={Array(4).fill({})}
                isLoading={true}
              />
            ))}
          </View>
        </View>
      </Page>

      {/** SKILLS */}
      <Page {...pageProps}>
        <TitleDescription title='' description='' isLoading={true} />
        <View style={{ marginTop: 24 }} className='flex flex-col gap-y-4'>
          {mockDimensionCards.map((_, index) => (
            <DimensionCard
              key={index}
              title=''
              talentScore={0}
              endPoleLeftTitle=''
              endPoleRightTitle=''
              insightDescription=''
              isLoading={true}
            />
          ))}
        </View>
      </Page>

      {/** PERSONALITY */}
      <Page {...pageProps}>
        <TitleDescription title='' description='' isLoading={true} />
        <View style={{ marginTop: 24 }} className='flex flex-col gap-y-4'>
          {mockDimensionCards.map((_, index) => (
            <DimensionCard
              key={index}
              title=''
              talentScore={0}
              endPoleLeftTitle=''
              endPoleRightTitle=''
              insightDescription=''
              isLoading={true}
            />
          ))}
        </View>
      </Page>

      {/** CULTURE */}
      <Page {...pageProps}>
        <TitleDescription title='' description='' isLoading={true} />
        <CultureFitContainer
          containerStyle={{ marginTop: 24, marginHorizontal: 24 }}
          title=''
          userCultureScores={{
            HEROS_JOURNEY_score_coopcomp: 0,
            HEROS_JOURNEY_score_orderchaos: 0
          }}
          insights={[]}
          isLoading={true}
        />
      </Page>

      {/** INTERESTS */}
      <Page {...pageProps}>
        <TitleDescription title='' description='' isLoading={true} />
        <View style={{ marginTop: 24 }} className='flex flex-col gap-y-4'>
          {mockDimensionCards.map((_, index) => (
            <DimensionCard
              key={index}
              title=''
              talentScore={0}
              endPoleLeftTitle=''
              endPoleRightTitle=''
              insightDescription=''
              isLoading={true}
            />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default TalentProfileLoading
